import React from 'react'
import Mapa from "./Mapa.js"
import './Footer.css'
function Footer() {
   return (

      <div className="footer">
        <div className="footer-content">
          <div className="footer-map">
            <Mapa />
          </div>
          <div className="footer-info">
            <div className="footer-section">
              <h4 className="footer-title" id="kontakt">Kontakty</h4>
              <ul className="footer-list">
                <li><a href="tel:775112341">Telefon: (+420)775 112 341</a></li>
                <li><a href="mailto:info@penzionjilovanka.cz">info@penzionjilovanka.cz</a></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4 className="footer-title">Adresa</h4>
              <ul className="footer-list">
                <li>Chata JÍLOVANKA</li>
                <li>Zdobnice 5</li>
                <li>516 01 Rychnov nad Kněžnou</li>
              </ul>
            </div>
            <div className="footer-section">
              <h4 className="footer-title">Majitel a provozovatel</h4>
              <ul className="footer-list">
                <li>Chata Jílovanka s.r.o.</li>
                <li>IČ: 10855408</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>Copyright &copy; 2026 Chata Jílovanka</p>
          <p>
            Web vytvořil{' '}
            <a href="https://matejstyblo.cz" target="_blank" rel="noopener noreferrer">
              matejstyblo.cz
            </a>
          </p>
        </div>
      </div>
   )
}

export default Footer
